import React from "react";
import { hasFullscreen } from "./../utils";
import { i18next } from "./../../wix-rich-content-common";
import { FullscreenProvider } from "../modals/fullscreen/fullscreen-provider";
import viewerVitalTranslations from "../translations/vitalTranslations.json";
import ContentViewer from "./ContentViewer";
const vitalTranslationsWithDefaults = addDefaultsFromEnglish(viewerVitalTranslations);
const TranslatedContentViewer = (props) => {
  const locale = props.locale;
  const [resourcesState, setResourcesState] = React.useState(() => {
    return {
      status: "READY",
      loadedLocales: ["en"],
      i18nextInstance: createI18nextInstance({
        activeLocale: locale,
        resources: vitalTranslationsWithDefaults
      })
    };
  });
  const { i18nextInstance, loadedLocales } = resourcesState;
  if (locale !== i18nextInstance.language) {
    i18nextInstance.changeLanguage(locale);
  }
  React.useEffect(() => {
    if (loadedLocales.includes(locale) || resourcesState.status !== "READY") {
      return;
    }
    setResourcesState((prevState) => ({ ...prevState, status: "LOADING" }));
    import(
      /* webpackChunkName: "ricos_viewer_messages_[request]" */
      `../translations/locale/messages_${locale}.json`
    ).then((response) => response.default).then((localeResource) => {
      i18nextInstance.addResourceBundle(locale, "translation", localeResource, true, true);
      setResourcesState((prevState) => {
        return {
          ...prevState,
          status: "READY",
          loadedLocales: [...prevState.loadedLocales, locale]
        };
      });
    }).catch((err) => {
      console.error(`can't find ${locale} locale`, err);
      setResourcesState((prevState) => {
        return { ...prevState, status: "ERROR" };
      });
    });
  }, [locale, loadedLocales]);
  const t = React.useMemo(() => i18nextInstance.t.bind(i18nextInstance), [i18nextInstance]);
  return hasFullscreen(props.config) ? /* @__PURE__ */ React.createElement(
    FullscreenProvider,
    {
      key: "RicosFullscreenProvider",
      fullscreenProps: props?.fullscreenProps,
      isMobile: !!props.isMobile,
      content: props.content,
      experiments: props.experiments,
      config: props.config,
      jsdomMode: props.jsdomMode,
      t
    },
    ({ config, onHover }) => /* @__PURE__ */ React.createElement(ContentViewer, { ...props, config, t, onHover })
  ) : /* @__PURE__ */ React.createElement(ContentViewer, { ...props, t });
};
function createI18nextInstance({
  activeLocale,
  resources
}) {
  const resourcesWithNs = Object.keys(resources).reduce((acc, key) => {
    acc[key] = { translation: resources[key] };
    return acc;
  }, {});
  const instance = i18next.createInstance({
    lng: activeLocale,
    keySeparator: "$",
    interpolation: { escapeValue: false },
    resources: resourcesWithNs
  });
  instance.init();
  return instance;
}
function addDefaultsFromEnglish(resources) {
  const english = resources.en;
  return Object.keys(resources).reduce((acc, locale) => {
    acc[locale] = { ...english, ...resources[locale] };
    return acc;
  }, {});
}
export {
  TranslatedContentViewer
};
//# sourceMappingURL=TranslatedContentViewer.js.map
